export function isRequestSuccessful(status: number): boolean {
  return status === 200 || status === 201 || status === 204;
}
